/**
 * Allow to build uri with params
 * @param path
 * @param filters
 * @returns {string}
 */
export function buildUriForCall (path, filters) {
  const filtersAsString = Object.fromEntries(
    Object.entries(filters)
      .filter(([key, value]) => value !== null && value !== '') // Filtrer les valeurs null
      .map(([key, value]) => [key, String(value)]) // Convertir en chaîne
  )

  if (Object.keys(filtersAsString).length !== 0 && filtersAsString.constructor === Object) {
    const params = new URLSearchParams(filtersAsString)
    path += `?${params.toString()}`
  }
  return path
}
